export default __webpack_public_path__ + "static/media/lte.033f224f.svg";